import { render } from "./ChatMediaAttachment.vue?vue&type=template&id=031983af"
import script from "./ChatMediaAttachment.vue?vue&type=script&lang=js"
export * from "./ChatMediaAttachment.vue?vue&type=script&lang=js"

import "./ChatMediaAttachment.vue?vue&type=style&index=0&id=031983af&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__